export default __webpack_public_path__ + "static/media/AW.2b0dddc3.svg";